import { render } from "./docSearchs2.vue?vue&type=template&id=15de6cfa&scoped=true"
import script from "./docSearchs2.vue?vue&type=script&lang=js"
export * from "./docSearchs2.vue?vue&type=script&lang=js"

import "./docSearchs2.vue?vue&type=style&index=0&id=15de6cfa&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15de6cfa"]])

export default __exports__